import React from 'react';

const ChooseUsSection = () => {
  return (
    <section className="chooseus-section pt_100 pb_65 centred">
      <div className="auto-container">
        <div className="sec-title mb_50">
          <span className="sub-title">Why Choose Shree Tours and Travels</span>
          <h2>What Makes Us the Best Choice</h2>
        </div>
        <div className="row clearfix">
          {/* 24/7 Support Block */}
          <div className="col-lg-3 col-md-6 col-sm-12 chooseus-block">
            <div className="chooseus-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-15"></i></div>
                <h3><a href="">24/7 Support</a></h3>
                <p>Our team is always ready to assist you, no matter the time of day. We're here whenever you need us!</p>
              </div>
            </div>
          </div>

          {/* Best Pricing Guarantee Block */}
          <div className="col-lg-3 col-md-6 col-sm-12 chooseus-block">
            <div className="chooseus-block-one wow fadeInUp animated" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-16"></i></div>
                <h3><a href="">Best Pricing Guarantee</a></h3>
                <p>We guarantee the best prices for your trips. Get value for your money with every booking.</p>
              </div>
            </div>
          </div>

          {/* On-time Pickup Block */}
          <div className="col-lg-3 col-md-6 col-sm-12 chooseus-block">
            <div className="chooseus-block-one wow fadeInUp animated" data-wow-delay="400ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-17"></i></div>
                <h3><a href="">On-time Pickup</a></h3>
                <p>We pride ourselves on punctuality. Your ride will be on time, every time, so you can travel with peace of mind.</p>
              </div>
            </div>
          </div>

          {/* Hassle-free Booking Block */}
          <div className="col-lg-3 col-md-6 col-sm-12 chooseus-block">
            <div className="chooseus-block-one wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="icon-box"><i className="icon-18"></i></div>
                <h3><a href="">Hassle-free Booking</a></h3>
                <p>Enjoy a seamless and simple booking process with no hidden fees. Plan your journey with ease!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChooseUsSection;
